import { provideLazy } from '@/generic/authentication/injections.ts';
import { AUTHENTICATION } from '@/generic/authentication/AuthenticationKeys.ts';
import { AuthenticationOpenId } from '@/generic/authentication/secondary/AuthenticationOpenId.ts';
import type { AuthenticationContextOpenId } from '@/generic/authentication/secondary/AuthenticationContextOpenId.ts';
import { AuthenticationFakeApi } from '@/generic/authentication/secondary/AuthenticationFakeApi.ts';

export const AUTHENTICATION_FAKE_API = Symbol('AuthenticationFakeApi');
export const AUTHENTICATION_OPENID = Symbol('AuthenticationOpenId');

type AuthenticationParameters<T> = {
  kind: T;
};

type AuthenticationAdapterFakeApi = AuthenticationParameters<typeof AUTHENTICATION_FAKE_API>;

type AuthenticationAdapterOpenId = AuthenticationParameters<typeof AUTHENTICATION_OPENID> &
  AuthenticationContextOpenId;

export type AuthenticationAdapter = AuthenticationAdapterFakeApi | AuthenticationAdapterOpenId;

type AuthenticationProvided = {
  adapter: AuthenticationAdapter;
};

const decideAuthentication = (adapter: AuthenticationAdapter) => {
  switch (adapter.kind) {
    case AUTHENTICATION_FAKE_API:
      return new AuthenticationFakeApi();
    case AUTHENTICATION_OPENID:
      return new AuthenticationOpenId(adapter);
  }
};

export const provideAuthentication = ({ adapter }: AuthenticationProvided) => {
  provideLazy(AUTHENTICATION, () => decideAuthentication(adapter));
};
